import { Box } from "@mui/system";
import { ReactNode, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IMenuState, setModalCloser } from "../../stateManagement/reducers/menuReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import { PopUpBg, PopUpContainer } from "./Style";

interface PopUpProps {
    id: number | string;
    children: ReactNode;
    deployed: boolean;
    setDeployed: (truth: boolean) => void;
    notCloseable?: boolean;
    isDirectChild?: boolean;
    bgColor?: string;
    position?: string;
    showParent?: () => any;
}

const PopUp: React.FC<PopUpProps> = ({ id, children, deployed, setDeployed, notCloseable, isDirectChild, bgColor, position, showParent }) => {

    const popUpId = `popUp${id}`;

    const dispatch = useDispatch<any>();
    const [isDeployed, setIsDeployed] = useState(false);

    const [count, setCount] = useState(0);

    const { openModal } = useSelector<IRootReducerT, IMenuState>(state => state.menu);

    useEffect(() => {
        if (isDeployed) {
            if (!isDirectChild) {
                dispatch(setModalCloser(setDeployed));
            }
        }


    }, [deployed, isDeployed]);

    useEffect(() => {

        setCount(count + 1);

        if (!openModal) {
            if (isDeployed) {
                if (!isDirectChild) {
                    setDeployed(false);
                }
            }
        }
    }, [openModal]);


    const closeWithStyle = () => {

        if (notCloseable) {
            return;
        }
        const popUp = document.getElementById(popUpId);

        if (!popUp) {
            throw new Error(`Pop-up with ID '${id}' missing.`);
        }

        popUp.classList.remove('show');

        if (notCloseable) {
            setTimeout(() => setDeployed(false), 250);
        } else {
            setTimeout(() => setIsDeployed(false), 250);
        }

        setTimeout(() => {
            if (showParent) {
                showParent();
            }
        }, 1000);
    }

    const [isInitRender, setIsInitRender] = useState(true);
    useEffect(() => {
        if (isInitRender) {
            setIsInitRender(false);
            return;
        }

        if (deployed) {
            setIsDeployed(true);
        } else {
            closeWithStyle();
        }
    }, [deployed])


    return (
        <>
            {
                ((isDeployed && !notCloseable) || (deployed && notCloseable))

                &&

                <PopUpContainer position={position} isDirectChild={isDirectChild} bgColor={bgColor} id={popUpId} className="show">
                    {
                        !isDirectChild

                        &&

                        <PopUpBg
                            onClick={() => {
                                if (notCloseable) {
                                    closeWithStyle();
                                } else {

                                    setDeployed(false)
                                }
                            }}
                        />
                    }
                    {
                        !isDirectChild

                        &&

                        <div className="scrollable" >
                            <span>
                                {children}
                            </span>
                            <div className="bg" onClick={() => {
                                if (notCloseable) {
                                    closeWithStyle();
                                } else {

                                    setDeployed(false)
                                }
                            }}></div>
                        </div>
                    }
                    {
                        isDirectChild

                        &&

                        <>
                            {children}
                        </>
                    }
                </PopUpContainer>

            }
        </>

    );
}

export default PopUp;